/**
 * The navigation's colours, matched to myRxVisit.com so the two sites read as siblings.
 *
 * Sampled from the myRxVisit screenshot: its top bar and headings are #0a2238, its call-to-action
 * salmon is #df8679, and its links are #3c788a — the same salmon and teal as the Truentity Health
 * lockup, over a deep navy ground.
 *
 * Two selected-state salmons, because the accessibility floors differ: a graphical object needs
 * 3:1 against its background and text needs 4.5:1.  The rail's selected icons carry no label, so
 * they take the lighter salmon and land closest to the logo; a selected menu row has a label
 * beside its icon, so it takes the deeper one.  Every value is measured, not guessed:
 *
 *   rail     #0a2238  white text 16.2:1   (sampled from myRxVisit)
 *   pane     #425261  white text  8.0:1   (2.0:1 against the rail, so the columns read apart)
 *   hover    #536779  white text  5.9:1
 *   inkIcon  #eb6251  on white    3.3:1   (icons only; 1.3:1 from the logo salmon)
 *   ink      #d72d19  on white    4.9:1   (rows with text; 1.9:1 from the logo salmon)
 *   teal     #3c788a  on white    5.0:1   (sampled from myRxVisit)
 */
export const NAV_COLORS = {
  /** The link list's ground — deliberately quieter than the rail. */
  pane: '#425261',
  /** The icon rail and its dock, the deep navy myRxVisit leads with. */
  rail: '#0a2238',
  /** Hover and pressed states on the main pane. */
  hover: '#536779',
  /**
   * The patient tab's ground, from the logo mark's teal.  The shift is in hue rather than
   * brightness — the two panes are never on screen together, so what tells them apart over time
   * is colour, and both keep the same comfortable contrast behind white text.
   *
   *   paneAlt       #2b4f5a  white text 8.9:1
   *   paneAltHover  #3a6a79  white text 6.0:1
   */
  paneAlt: '#2b4f5a',
  paneAltHover: '#3a6a79',
  /** Selected foreground where a label is present, so it clears the 4.5:1 text floor. */
  ink: '#d72d19',
  /** Selected foreground for bare icons, which need only 3:1 and so sit nearer the logo. */
  inkIcon: '#eb6251',
  /** Everything sitting on pane or rail. */
  onDark: '#ffffff',
  /** Resting label colour: white at ease rather than full strength. */
  onDarkMuted: 'rgba(255, 255, 255, 0.82)',
  /** The link teal, for accents in the white top bar. */
  teal: '#3c788a'
} as const;
